import React, { useEffect, useState } from 'react';
import { default as Form } from '../../components/connectedForm';
import { useCompany } from '../../utils/FetchConfig';
import { IFinancialCalendar, Maybe } from '../../graphql/schema/p4types';
import { DocumentNode } from 'graphql';
import PeriodBudgets, { IPeriodBudgetsProps } from '../../components/connectedForm/PeriodBudgets/PeriodBudgets';

export type BudgetTabProps = {
  type: string;
  profileDropdown: {
    query: DocumentNode;
    valueKey: string;
    labelKey: string;
  };
};

const BudgetTab = ({ type, profileDropdown }: BudgetTabProps) => {
  const company = useCompany();

  const [currentYear, setCurrentYear] = useState<Maybe<IFinancialCalendar>>(null);
  const [nextYear, setNextYear] = useState<Maybe<IFinancialCalendar>>(null);

  useEffect(() => {
    if (company) {
      setCurrentYear(company.currentFinancialYear);
      setNextYear(company.nextFinancialYear);
    }
  }, [company]);

  return (
    <>
      <Form.Row>
        <Form.Fieldset cols={1 / 2}>
          <Form.Legend label={`${currentYear?.year} Budget`} />
          <Form.Field<IPeriodBudgetsProps>
            dataid={`${type}Budgets`}
            component={PeriodBudgets}
            financialYear={currentYear}
            forceUpdate={true}
            profileDropdown={profileDropdown}
          />
        </Form.Fieldset>
        <Form.Fieldset cols={1 / 2}>
          <Form.Legend label={`${nextYear && nextYear?.year ? nextYear?.year : 'Next Years'} Budget`} />
          <Form.Field<IPeriodBudgetsProps>
            dataid={`${type}Budgets`}
            component={PeriodBudgets}
            financialYear={nextYear}
            forceUpdate={true}
            profileDropdown={profileDropdown}
          />
        </Form.Fieldset>
      </Form.Row>
    </>
  );
};

export default BudgetTab;
